import "./style.css";
import { Card, Col, Row, Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useRequiredAccess } from "../../hooks/useRequiredAccess";
import VehiclesListTable from "../Common/VehiclesListTable";
import LeaderBoard from "./LeaderBoard";
import LocationsCard from "./LocationsCard";
import {
  vehicleStatusCountApiUrl,
  vehicleStatusListApiUrl,
} from "../Common/endpoints";
import { getApis } from "../Common/apis";
import {
  setPageLoader,
  setPageLastUpdatedTime,
} from "../../reducers/loaderSlice";
import { ORG_TYPES } from "../Common/Constants";
import { VEHICLE_STATUS } from "./constants";

const Home = () => {
  const dispatch = useDispatch();
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );
  const authToken = localStorage.getItem("authToken");
  const [vehicleListModalDetails, setVehicleListModalDetails] = useState({
    status: null,
  });
  const [vehicleStatusCountDetails, setVehicleStatusCountDetails] = useState(
    {}
  );
  const [clickedCard, setClickedCard] = useState("");

  const vehicleStatusCardDetails = VEHICLE_STATUS.map((status, index) => {
    return {
      name: status.name,
      text: status.name.charAt(0).toUpperCase() + status.name.slice(1),
      icon: status.renderIcon,
      style: {
        borderRadius: "16px",
        // height: '100%',
        // background: status.markerColor,
        // boxShadow: '0px 20px 50px 0px rgba(0, 0, 0, 0.07)',
      },
    };
  });

  const getVehicleStatusCount = useCallback(async () => {
    await getApis(vehicleStatusCountApiUrl, {}, authToken)
      .then((response) => {
        setVehicleStatusCountDetails(response?.data);
        dispatch(setPageLoader("live"));
        dispatch(setPageLastUpdatedTime(Date.now()));
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        dispatch(setPageLoader("live"));
        //dispatch(setPageLastUpdatedTime(Date.now()));
        // need not update time as api FAILED
      });

    // eslint-disable-next-line
  }, [authToken]);

  const getVehicleStatusList = async () => {
    await getApis(
      vehicleStatusListApiUrl,
      {
        page: 0,
        size: 10,
      },
      authToken
    )
      .then((response) => {
        setVehicleListModalDetails((prev) => ({
          ...prev,
          ...(response?.data || {}),
        }));
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        setVehicleListModalDetails({ status: null });
      });
  };

  useEffect(() => {
    checkAccess();
    dispatch(setPageLoader("refresh"));
    getVehicleStatusCount();
    getVehicleStatusList();

    const intervalId = setInterval(() => {
      dispatch(setPageLoader("refresh"));
      getVehicleStatusCount();
      getVehicleStatusList();
    }, 60 * 1000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, []);

  const renderVehicleListModal = (status) => {
    return (
      <Modal
        title={
          vehicleListModalDetails?.status[0] +
          vehicleListModalDetails?.status.slice(1).toLowerCase() +
          " Vehicles"
        }
        open={vehicleListModalDetails?.status !== null}
        onCancel={() => {
          setVehicleListModalDetails((prev) => ({ ...prev, status: null }));
          setClickedCard("");
          console.log("close->", clickedCard);
        }}
        className="vehicle-status-list-modal"
        footer={false}
        width={600}
        style={{ top: "20px" }}
      >
        <VehiclesListTable vehicleListModalDetails={vehicleListModalDetails} />
      </Modal>
    );
  };

  return (
    <div className="home" data-testid="home">
      {vehicleListModalDetails?.status
        ? renderVehicleListModal(vehicleListModalDetails?.status)
        : null}
      <Row gutter={[16, 16]}>
        {vehicleStatusCardDetails.map((status, index) => {
          const count = vehicleStatusCountDetails?.[status.name] || 0;
          return (
            <Col key={index} xs={24} sm={8} md={8} lg={4} xl={4}>
              <Card
                bordered={false}
                // className={clickedCard === status.name ? status.name + " status-card-active" : status.name + " status-card" }
                className={status.name + " status-card"}
                style={status.style}
              >
                <div className="w100 h100">
                  <Row gutter={[2, 2]} justify="space-between">
                    <Col>
                      <span className="status-title">{status.text}</span>
                    </Col>
                    <Col>
                      <status.icon className="status-icon" />
                    </Col>
                  </Row>
                  <Row gutter={[2, 2]} justify="center">
                    <Col
                      span={24}
                      onClick={
                        count
                          ? () => {
                              setVehicleListModalDetails((prev) => ({
                                ...prev,
                                status: status.name.toUpperCase(),
                              }));
                              setClickedCard(status.name);
                            }
                          : null
                      }
                    >
                      <span
                        className={
                          !count
                            ? "status-count text-center list-disabled"
                            : "status-count text-center"
                        }
                      >
                        {count}
                      </span>
                      {/* <span className="text-center status-count">{count}</span> */}
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
      <Row gutter={[16, 16]} className="mt1">
        <Col xs={24} sm={24} md={24} lg={12} xl={12} id="map">
          <LocationsCard />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <LeaderBoard />
        </Col>
      </Row>
    </div>
  );
};

export default Home;
